import { OrganizationType } from 'globalTypes';

import { touch } from 'actions/touchActions';
import districtImage from 'assets/images/admin/district.svg';
import { AvatarImages } from 'constants/AvatarConstants';
import { DEFAULT_COLOR } from 'entities/Group';
import User from 'entities/User';
import apiRequest from 'lib/apiRequest';
import Entity from 'lib/Entity';

export default class Organization extends Entity {
  initialize() {
    this.urlRoot = '/organizations';
  }

  defaults() {
    return {
      admins: [],
      approval_settings: {
        require_class_approval: false,
        gate_teacher_role: false,
      },
    };
  }

  getUuid(): string {
    return this.get('uuid');
  }

  getName(): string {
    return this.get('name');
  }

  getType(): OrganizationType {
    return this.get('type') || 'School';
  }

  getCity(): string | undefined {
    return this.get('city');
  }

  getState(): string | undefined {
    return this.get('state');
  }

  getFormattedAddress() {
    return this.get('formatted_address');
  }

  getMemberSampleString(): string | undefined {
    return this.get('members_sample_string');
  }

  getAdmins(): any[] {
    return this.get('admins');
  }

  getLatitude() {
    return this.get('latitude');
  }

  getLongitude() {
    return this.get('longitude');
  }

  getNCESId() {
    return this.get('nces_id');
  }

  getAccentColor() {
    return DEFAULT_COLOR;
  }

  getStatistics() {
    return this.get('org_stats');
  }

  getAvatarUrl() {
    const type = this.get('type');

    if (type === 'School') {
      return AvatarImages.ORG_AVATAR;
    } else if (type === 'District') {
      return districtImage;
    }

    throw new Error('Unsupported organization type ' + type);
  }

  hasAdmins() {
    return this.getAdmins().length > 0;
  }

  isAdminBy(user: User) {
    return this.getAdmins().some((admin) => admin.id === user.id);
  }

  isPaid() {
    return !!this.get('paidAt') || !!this.get('paid');
  }

  getApprovalSettings() {
    const settings = this.get('approval_settings');

    return {
      requireClassApproval: settings.require_class_approval,
      requireTeacherApproval: settings.gate_teacher_role,
    };
  }

  create() {
    return apiRequest('/organizations', 'POST', {
      organization: {
        name: this.getName(),
        city: this.getCity(),
        state: this.getState(),
        type: this.getType(),
        country: this.get('country'),
      },
    }).then((org) => {
      touch('NAVIGATION_LIST');
      return Organization.fromJSON(org);
    });
  }
}
